import { render, staticRenderFns } from "./HomeClinicCard.vue?vue&type=template&id=5602a255"
import script from "./HomeClinicCard.vue?vue&type=script&lang=js"
export * from "./HomeClinicCard.vue?vue&type=script&lang=js"
import style0 from "./HomeClinicCard.vue?vue&type=style&index=0&id=5602a255&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports